import { HttpClient } from '@angular/common/http';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { finalize } from 'rxjs/operators';

import { IParamMap, IResponse } from '@core/interfaces';

@Component({
  selector: 'eb-new-features-dialog',
  templateUrl: './new-features-dialog.component.html',
  styleUrls: ['./new-features-dialog.component.scss'],
  imports: [],
})
export class NewFeaturesDialogComponent implements OnInit, OnDestroy {
  features: IParamMap[];
  loading: boolean;

  private readonly http = inject(HttpClient);

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.loading = true;
    this.http
      .get<IResponse<any>>('/assets/data.json')
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((res: any) => (this.features = res));
  }

  close(): void {
    this.loading = true;
    window.location.reload();
  }

  ngOnDestroy(): void {
    this.close();
  }
}
